// extracted by mini-css-extract-plugin
module.exports = {"announcement-detail":"AnnouncementDetail_announcement-detail__QCXSP","announcement-date-label":"AnnouncementDetail_announcement-date-label__Ym7Gs"};